import type { Mouvement } from '@mairistem/comptabilite';
import ActionResultType from '../../../../interfaces/pieces/ActionResultType';
import type { BaseLiquidationOptions } from '../../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import MouvementActionType from '../../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type TreeviewActionResult from '../../../../interfaces/pieces/TreeviewActionResult';
import { supprimerMouvement } from '../../../../services/piecesComptables/mouvements/mouvements';
import afficherInfoChorus from '../../../../utils/chorus/afficherInfoChorus';
import getMessageErreur from '../../../../utils/getMessageErreur';
import BaseLiquidationAction from '../../../pieces/BaseLiquidationAction';

class MouvementSupprimerAction extends BaseLiquidationAction<
	Mouvement,
	MouvementActionType
> {
	constructor(options: BaseLiquidationOptions = null) {
		super(options);
		this.label = 'Supprimer';
		this.type = MouvementActionType.DELETE;
	}

	execute = (mouvement: Mouvement): TreeviewActionResult<Mouvement> => ({
		type: ActionResultType.MODAL,
		result: Promise.resolve(mouvement),
		extraProps: {
			deleteModal: {
				visible: true,
				typeAction: MouvementActionType.DELETE,
			},
		},
	});

	executeAction = (mouvement: Mouvement): TreeviewActionResult<Mouvement> => ({
		result: new Promise((resolve, reject) => {
			supprimerMouvement(mouvement.identifiant as number)
				.then((infoChorus) => {
					afficherInfoChorus(infoChorus);
					resolve(mouvement);
				})
				.catch((e) => {
					reject(
						Error(
							getMessageErreur(e, 'Erreur lors de la suppression du mouvement'),
						),
					);
				});
		}),
		type: ActionResultType.DELETE,
	});
}

export default MouvementSupprimerAction;
